import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { getBlogBySlug } from '../apis/blogApis';
import Loader from '../Components/Loader/Loader';

function BlogDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const data = await getBlogBySlug(slug);
        setBlog(data);
      } catch (err) {
        console.error("Blog not found:", err);
        navigate('/blog');
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [slug]);

  if (loading) return <Loader />;
  if (!blog) return null;

  return (
    <>
      <div className='blog-detail-img pt-[92px]'>
        <img src={blog.imageUrl || '/assets/blog11.jpg'} alt={blog.title} />
      </div>

      <div className='blog-detail-dec max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] lg:pb-[80px] pb-[40px]'>
        <div className='blog-detail-dec-img'>
          <div className='blog-detail-dec-img-left'>
            {blog.subtitle && <h3>{blog.subtitle}</h3>}
            <h4>{blog.title}</h4>

            {blog.author && (
              <p className="text-sm text-gray-500 mb-4">By {blog.author}</p>
            )}

            <div
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />

            {blog.tags && blog.tags.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-4">
                {blog.tags.map((tag, i) => (
                  <span key={i} className="bg-gray-100 text-gray-600 text-xs px-3 py-1 rounded-full">
                    #{tag}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className='blog-detail-dec-img-right'>
            <img src={blog.imageUrl || '/assets/blog12.jpg'} alt={blog.title} />
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogDetail;
